import { ITextBlock } from "src/components/Typography/types";
import { termsOfUseTrns } from "./trns";

const INTRODUCTION_BLOCK: ITextBlock = {
  id: "1",
  textSubBlocks: [
    { id: "1.1", text: { i18nKey: termsOfUseTrns.introductionContent } },
  ],
};

const ABOUT_BLOCK: ITextBlock = {
  id: "2",
  title: {
    i18nKey: termsOfUseTrns.aboutTitle,
  },
  textSubBlocks: [
    {
      id: "2.1",
      text: { i18nKey: termsOfUseTrns.aboutContent },
    },
  ],
};

const DESCRIPTION_OF_SERVICES_BLOCK: ITextBlock = {
  id: "3",
  title: {
    i18nKey: termsOfUseTrns.descriptionOfServicesTitle,
  },

  textSubBlocks: [
    {
      id: "3.1",
      text: { i18nKey: termsOfUseTrns.descriptionOfServicesContent },
    },
  ],
};

const USER_ACCOUT_BLOCK: ITextBlock = {
  id: "4",
  title: {
    i18nKey: termsOfUseTrns.userAccountTitle,
  },
  textSubBlocks: [
    {
      id: "4.1",
      text: { i18nKey: termsOfUseTrns.userAccountContent },
    },
  ],
};

const USER_OBLIGATIONS_BLOCK: ITextBlock = {
  id: "5",
  title: {
    i18nKey: termsOfUseTrns.userObligationsTitle,
  },
  textSubBlocks: [
    {
      id: "5.1",
      text: { i18nKey: termsOfUseTrns.userObligationsContent },
    },
  ],
};

const BUSSINESS_CLONES_RESPONSIBILITIES_BLOCK: ITextBlock = {
  id: "6",
  title: {
    i18nKey: termsOfUseTrns.businessClonsResponsibilitiesTitle,
  },
  textSubBlocks: [
    {
      id: "6.1",
      text: { i18nKey: termsOfUseTrns.businessClonsResponsibilitiesContent },
    },
  ],
};

const INTELLECTUAL_PROPERTY_RIGHTS_BLOCK: ITextBlock = {
  id: "7",
  title: {
    i18nKey: termsOfUseTrns.intellectualPropertyRightsTitle,
  },
  textSubBlocks: [
    {
      id: "7.1",
      text: { i18nKey: termsOfUseTrns.intellectualPropertyRightsContent },
    },
  ],
};

const CHANGES_TERMS_OF_USE_BLOCK: ITextBlock = {
  id: "8",
  title: {
    i18nKey: termsOfUseTrns.changesTermsOfUseTitle,
  },
  textSubBlocks: [
    {
      id: "8.1",
      text: { i18nKey: termsOfUseTrns.changesTermsOfUseContent },
    },
  ],
};

const PRICING_CHANGES_BLOCK: ITextBlock = {
  id: "9",
  title: {
    i18nKey: termsOfUseTrns.pricingChangesTitle,
  },
  textSubBlocks: [
    {
      id: "9.1",
      text: { i18nKey: termsOfUseTrns.pricingChangesContent },
    },
  ],
};

const SELLER_PRICE_CHANGES_BLOCK: ITextBlock = {
  id: "10",
  title: {
    i18nKey: termsOfUseTrns.sellerPriceChangesTitle,
  },
  textSubBlocks: [
    {
      id: "10.1",
      text: { i18nKey: termsOfUseTrns.sellerPriceChangesContent },
    },
  ],
};

const DISPUTE_RESOLUTION_BLOCK: ITextBlock = {
  id: "11",
  title: {
    i18nKey: termsOfUseTrns.disputeResolutionTitle,
  },
  textSubBlocks: [
    {
      id: "11.1",
      text: { i18nKey: termsOfUseTrns.disputeResolutionContent },
    },
  ],
};

const PROHIBITED_ACTIONS_BLOCK: ITextBlock = {
  id: "12",
  title: {
    i18nKey: termsOfUseTrns.prohibitedActionsTitle,
  },
  textSubBlocks: [
    {
      id: "12.1",
      text: { i18nKey: termsOfUseTrns.prohibitedActionsContent },
    },
  ],
};

const PRIVACY_POLICY_BLOCK: ITextBlock = {
  id: "13",
  title: {
    i18nKey: termsOfUseTrns.privacyPolicyTitle,
  },
  textSubBlocks: [
    {
      id: "13.1",
      text: { i18nKey: termsOfUseTrns.privacyPolicyContent },
    },
  ],
};

const USE_OF_COOKIES_BLOCK: ITextBlock = {
  id: "14",
  title: {
    i18nKey: termsOfUseTrns.useOfCookiesTitle,
  },
  textSubBlocks: [
    {
      id: "14.1",
      text: { i18nKey: termsOfUseTrns.useOfCookiesContent },
    },
  ],
};

const RIGHTS_OF_PARTIES_BLOCK: ITextBlock = {
  id: "15",
  title: {
    i18nKey: termsOfUseTrns.rightsOfPartiesTitle,
  },
  textSubBlocks: [
    {
      id: "15.1",
      subheading: {
        i18nKey: termsOfUseTrns.userRightsTitle,
      },
      text: { i18nKey: termsOfUseTrns.userRightsContent },
    },
    {
      id: "15.2",
      subheading: {
        i18nKey: termsOfUseTrns.userObligationsSecondTitle,
      },
      text: {
        i18nKey: termsOfUseTrns.userObligationsSecondContent,
      },
    },
    {
      id: "15.3",
      subheading: {
        i18nKey: termsOfUseTrns.businessClonRightsTitle,
      },
      text: {
        i18nKey: termsOfUseTrns.businessClonRightsContent,
      },
    },
    {
      id: "15.4",
      subheading: {
        i18nKey: termsOfUseTrns.businessClonObligationsTitle,
      },
      text: {
        i18nKey: termsOfUseTrns.businessClonObligationsContent,
      },
    },
  ],
};

const SECOND_DISPUTE_RESOLUTION_BLOCK: ITextBlock = {
  id: "16",
  title: {
    i18nKey: termsOfUseTrns.secondDisputeResolutionTitle,
  },
  textSubBlocks: [
    {
      id: "16.1",
      text: { i18nKey: termsOfUseTrns.secondDisputeResolutionContent },
    },
  ],
};

const TERMINATION_OF_USE_BLOCK: ITextBlock = {
  id: "17",
  title: {
    i18nKey: termsOfUseTrns.terminationOfUseTitle,
  },
  textSubBlocks: [
    {
      id: "17.1",
      text: { i18nKey: termsOfUseTrns.terminationOfUseContent },
    },
  ],
};

const MISCELLANEOUS_PROVISIONS_BLOCK: ITextBlock = {
  id: "18",
  title: {
    i18nKey: termsOfUseTrns.miscellaneousProvisionsTitle,
  },
  textSubBlocks: [
    {
      id: "18.1",
      text: { i18nKey: termsOfUseTrns.miscellaneousProvisionsContent },
    },
  ],
};

const CONTACT_INFORMATION_BLOCK: ITextBlock = {
  id: "19",
  title: {
    i18nKey: termsOfUseTrns.contactInfoTitle,
  },
  textSubBlocks: [
    {
      id: "19.1",
      text: { i18nKey: termsOfUseTrns.contactInfoContent },
    },
  ],
};

export const TERMS_OF_USE_BLOCKS: ITextBlock[] = [
  INTRODUCTION_BLOCK,
  ABOUT_BLOCK,
  DESCRIPTION_OF_SERVICES_BLOCK,
  USER_ACCOUT_BLOCK,
  USER_OBLIGATIONS_BLOCK,
  BUSSINESS_CLONES_RESPONSIBILITIES_BLOCK,
  INTELLECTUAL_PROPERTY_RIGHTS_BLOCK,
  CHANGES_TERMS_OF_USE_BLOCK,
  PRICING_CHANGES_BLOCK,
  SELLER_PRICE_CHANGES_BLOCK,
  DISPUTE_RESOLUTION_BLOCK,
  PROHIBITED_ACTIONS_BLOCK,
  PRIVACY_POLICY_BLOCK,
  USE_OF_COOKIES_BLOCK,
  RIGHTS_OF_PARTIES_BLOCK,
  SECOND_DISPUTE_RESOLUTION_BLOCK,
  TERMINATION_OF_USE_BLOCK,
  MISCELLANEOUS_PROVISIONS_BLOCK,
  CONTACT_INFORMATION_BLOCK,
];
